import { useRef } from 'react';
import { useScroll, useTransform } from 'framer-motion';

// Ties a ref'd element's vertical offset to scroll progress, creating a
// subtle parallax drift (background moves slower than foreground content).
export function useParallax(distance = 60) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [0, distance]);
  return { ref, y };
}
